import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

const STUDIO_AI_API_VERSION = featureFlagMixin.methods.isFeatureEnabled('studio_ai_api_v3') ? 'v3' : 'v2';
// SEO
const ORGANIZATION_SCHEMA = {
  '@type': 'Organization',
  name: 'MotionElements',
  url: 'https://www.motionelements.com',
};

// eslint-disable-next-line
export {
  // eslint-disable-next-line
  STUDIO_AI_API_VERSION,
  ORGANIZATION_SCHEMA,
};
